import { apiGet } from './index'

export function getData(data) {
  let url;
  if (/^\d+$/.test(data)) {
    // 如果 data 是純數字（可以包含前導 0）
    url = "/api/Chart/list/" + data;
  } else {
    // 如果 data 不是純數字
    url = "/api/Chart/future/" + data;
  }

  return apiGet(url, { params: { timestamp: Math.random() } });
}
